import React, { useState, useEffect } from "react";
import { useAuthForm } from "../../context/AuthFormContext";
import Button from "../ui/Button";
import FormError from "../ui/FormError";
import FormGroup from "../ui/FormGroup";
import { validatePassword } from "../../utils/validation";
import Input from "../ui/Input";

const PasswordResetView: React.FC = () => {
	const { state, resetPasswordWithToken } = useAuthForm();
	const [password, setPassword] = useState("");
	const [token, setToken] = useState<string>("");
	const [formError, setFormError] = useState<string | null>(null);

	useEffect(() => {
		// Extract token from URL query parameter
		const searchParams = new URLSearchParams(window.location.search);
		const tokenFromUrl = searchParams.get("token") || "";
		setToken(tokenFromUrl);

		if (!tokenFromUrl) {
			console.error("No token found in URL");
		}
	}, []);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setFormError(null);

		if (!token) {
			console.error("Cannot reset password: token is missing");
			setFormError("Токен для восстановления пароля не найден");
			return;
		}

		const passwordValidation = validatePassword(password);
		if (!passwordValidation.valid) {
			setFormError(passwordValidation.error!);
			return;
		}

		await resetPasswordWithToken(token, password);
	};

	return (
		<div className="auth-view">
			<h3 className="tw-text-xl tw-font-semibold tw-text-gray-800 tw-mb-6 tw-text-center">Изменения пароля</h3>

			<p className="tw-mb-6 tw-text-gray-600">Введите новый пароль. Убедитесь, что он надёжный и отличается от предыдущего</p>

			<form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4">
				<FormGroup>
					<Input id="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Введите новый пароль" required disabled={state.status === "submitting"} passwordToggle={true} />
				</FormGroup>

				{!token && <div className="tw-mb-4 tw-p-3 tw-bg-red-50 tw-text-red-700 tw-rounded">Токен для восстановления пароля не найден в URL. Пожалуйста, перейдите по ссылке из письма.</div>}

				<FormError message={formError} />
				<FormError message={state.status === "error" ? state.error : null} />
				{state.status === "success" && <div className="tw-p-3 tw-bg-green-50 tw-text-green-700 tw-rounded tw-text-sm tw-border tw-border-green-200">Пароль успешно изменен!</div>}

				<Button type="submit" variant="primary" loading={state.status === "submitting"} disabled={state.status === "submitting" || !password || !token} className="tw-w-full">
					{state.status === "submitting" ? "Изменение..." : "Продолжить"}
				</Button>
			</form>
		</div>
	);
};

export default PasswordResetView;
